
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comparepeorates/[category]",
      function () {
        return require("private-next-pages/comparepeorates/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comparepeorates/[category]"])
      });
    }
  